<template>
    <div v-if="pagination.last > 1" class="mx-0">
        <nav aria-label="Page navigation">
            <ul class="pagination m-0">
                <li :class="pagination.current <= 1 ? 'disabled' : ''" class="page-item">
                    <button @click="$emit('fetch-results', 1)"
                            class="page-link" aria-label="First" type="button">
                        First
                    </button>
                </li>

                <li :class="pagination.current <= 1 ? 'disabled' : ''" class="page-item">
                    <button @click="$emit('fetch-results', pagination.current - 1)"
                            class="page-link" aria-label="Previous" type="button">
                        Prev
                    </button>
                </li>

                <li aria-current="page">
                    <span class="page-link">{{ pagination.current + " / " + pagination.last }}</span>
                </li>

                <li :class="pagination.current >= pagination.last ? 'disabled' : ''" class="page-item">
                    <button @click="$emit('fetch-results', pagination.current + 1)"
                            class="page-link" aria-label="Next" type="button">
                        Next
                    </button>
                </li>

                <li :class="pagination.current >= pagination.last ? 'disabled' : ''" class="page-item">
                    <button @click="$emit('fetch-results', pagination.last)"
                            class="page-link" aria-label="Last" type="button">
                        Last
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        pagination: {type: Object, required: true},
    },
}
</script>

<style scoped>

</style>
